import React from 'react';
import { legalTransparency } from '../data/mock';
import { Scale } from 'lucide-react';

const LegalSection = () => {
  return (
    <section className="bg-black py-16 lg:py-20">
      <div className="max-w-4xl mx-auto px-6 lg:px-8">
        <div className="border border-[#D4AF37]/30 p-8 lg:p-12 animate-fade-in-up">
          <div className="flex items-start gap-6">
            {/* Icon */}
            <div className="flex-shrink-0 hidden sm:flex w-14 h-14 items-center justify-center border border-[#D4AF37]/40 bg-[#D4AF37]/10">
              <Scale className="h-7 w-7 text-[#D4AF37]" />
            </div>

            {/* Content */}
            <div>
              <h3 className="text-xl font-semibold gold-text mb-4">
                {legalTransparency.title}
              </h3>
              <p className="text-white/60 text-sm leading-relaxed">
                {legalTransparency.text}
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default LegalSection;
